import { IconButton, Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';
import { MdDesktopMac, MdSend, MdSync, MdCancel, MdGetApp, MdPictureAsPdf, MdSearch, MdBlock } from 'react-icons/md';
import { FaFileCode } from 'react-icons/fa';

export default function MdfeMenu({ 
  data, 
  onEmitir, 
  onConsultar, 
  onCancelar, 
  onEncerrar, 
  onBaixarPdf, 
  onBaixarXml, 
  onSincronizar 
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = async (action) => {
    try {
      switch (action) {
        case 'Emitir':
          if (onEmitir) {
            await onEmitir(data);
          }
          break;
        case 'Consultar':
          if (onConsultar) {
            await onConsultar(data);
          }
          break;
        case 'Cancelar':
          if (onCancelar) {
            // Abrir modal de justificativa (não usar prompt)
            await onCancelar(data);
          }
          break;
        case 'Encerrar':
          if (onEncerrar) {
            // Abrir modal de encerramento (não usar prompt)
            await onEncerrar(data);
          }
          break;
        case 'Baixar PDF':
          if (onBaixarPdf) {
            await onBaixarPdf(data);
          }
          break;
        case 'Baixar XML':
          if (onBaixarXml) {
            await onBaixarXml(data);
          }
          break;
        case 'Sincronizar dados':
          if (onSincronizar) {
            await onSincronizar(data);
          }
          break;
        default:
          break;
      }
      handleClose();
    } catch (error) {
      console.error(`Erro ao executar ação ${action}:`, error);
      // Erro já foi tratado nas funções, apenas fechar o menu
      handleClose();
    }
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        style={{ padding: '4px', marginLeft: '8px' }}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
      >
        <MdDesktopMac size={17} style={{ color: '#122d58' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleAction('Emitir')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdSend size={18} style={{ color: '#4caf50' }} />
          Emitir
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Consultar')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdSearch size={18} style={{ color: '#2196F3' }} />
          Consultar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Cancelar')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdCancel size={18} style={{ color: '#f27160' }} />
          Cancelar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Encerrar')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdBlock size={18} style={{ color: '#f27160' }} />
          Encerrar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Baixar PDF')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdPictureAsPdf size={18} style={{ color: '#f44336' }} />
          Baixar PDF
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Baixar XML')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <FaFileCode size={16} style={{ color: '#FF9800' }} />
          Baixar XML
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Sincronizar dados')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdSync size={18} style={{ color: '#2196F3' }} />
          Sincronizar dados
        </MenuItem>
      </Menu>
    </>
  );
}

